"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.facilityIdParamSchema = exports.facilityPageSchema = exports.listFacilitiesQuerySchema = exports.facilitySchema = exports.patientIdParamSchema = exports.patientPageSchema = exports.listPatientsQuerySchema = exports.patientDetailSchema = exports.patientSummarySchema = exports.TELEMETRY_PATHS = exports.listUsersQuerySchema = exports.pingSchema = exports.healthSchema = exports.errorSchema = exports.idParamSchema = exports.adminAccountSchema = exports.sampleRecordSchema = exports.userPublicSchema = void 0;
// @chartvn/schema — the T11 source of truth. Server routes and web forms import from here.
// Database tables live under "@chartvn/schema/db" (server only); permissions under "@chartvn/schema/permissions".
const zod_1 = require("zod");
__exportStar(require("./permissions.js"), exports);
// Row-level attribution: the shapes of `03-RPM-SCHEMA.md` §9.6, the eight exclusions of §9.3, and
// the two checks that read them (`RPM-054`, J-244).
__exportStar(require("./attribution.js"), exports);
// §4.4's gate check: no foreign key points into a schema this system mirrors and does not write
// (`RPM-081`, N15, `CR-31`, J-246).
__exportStar(require("./external-references.js"), exports);
// The actor is a `user` id: the catalogue carries no actor's name as text, and no route input
// accepts one (`RPM-083`, D5, N17, J-247).
__exportStar(require("./actor-identity.js"), exports);
// `RPM-102` rows 3 and 7: the clinical path reads an account and never a person, and the one
// administrative surface that does read one joins it outward (`CR-12`, J-248).
__exportStar(require("./people-joins.js"), exports);
// `RPM-003`: the reference set `GET /api/rpm/v1/reference/vitals` returns — one LOINC code and one
// canonical UCUM unit per classified vital, with its plausibility bounds (J-250).
__exportStar(require("./rpm-reference.js"), exports);
__exportStar(require("./rpm-entries.js"), exports);
// Time on the entry: one tick of the browser's steady clock, and the entry's total (`RPM-106`, `J-601`).
__exportStar(require("./rpm-entry-time.js"), exports);
// The one reading of a typed date and time, for the server and the form alike (`J-571`).
__exportStar(require("./local-date-time.js"), exports);
__exportStar(require("./rpm-corrections.js"), exports);
__exportStar(require("./rpm-source-systems.js"), exports);
__exportStar(require("./rpm-scoring.js"), exports);
__exportStar(require("./rpm-alert-history.js"), exports);
__exportStar(require("./rpm-lane-override.js"), exports);
__exportStar(require("./rpm-note.js"), exports);
__exportStar(require("./rpm-readings.js"), exports);
__exportStar(require("./rpm-entry-worklist.js"), exports);
// `RPM-096`: the facility pick list `GET /api/rpm/v1/facilities` returns (J-213).
__exportStar(require("./rpm-facilities.js"), exports);
// `RPM-028`: a building's operative zone, read and changed on the administration form (J-276).
__exportStar(require("./rpm-facility-profile.js"), exports);
__exportStar(require("./rpm-blast-radius.js"), exports);
// `RPM-058`, `RPM-059`: a band set as a partition, and the editor's list, read and publish (J-292, J-293).
__exportStar(require("./band-partition.js"), exports);
__exportStar(require("./rpm-band-sets.js"), exports);
// `RPM-031`: a building's care units, set up by an administrator and offered at entry (J-224).
__exportStar(require("./rpm-care-units.js"), exports);
// `RPM-036`: a building's routing profile, read and changed on the routing screen (J-225).
__exportStar(require("./rpm-facility-routing.js"), exports);
// `RPM-044`: the tenant's standing copies, maintained by an administrator (J-282).
__exportStar(require("./rpm-standing-ccs.js"), exports);
// `RPM-105`: a building's routing directory, its contacts and their endpoints (J-487).
__exportStar(require("./rpm-routing-directory.js"), exports);
// `RPM-092`: the message-content lines, the tenant's defaults and each building's own (J-296).
__exportStar(require("./rpm-content-lines.js"), exports);
// `RPM-062`: each building's readiness, in the nurse's words (J-283).
__exportStar(require("./rpm-readiness.js"), exports);
// `RPM-061`: the onboarding checklist, every building of the tenant with what it needs (J-295).
__exportStar(require("./rpm-onboarding.js"), exports);
// `RPM-063`: a configuration record's change history, read on its own screen (J-291).
__exportStar(require("./rpm-change-history.js"), exports);
__exportStar(require("./rpm-alert-routing.js"), exports);
__exportStar(require("./rpm-routing-import.js"), exports);
__exportStar(require("./tenant-context.js"), exports);
__exportStar(require("./rpm-role-assignments.js"), exports);
// `RPM-064`: the platform operator's routes, `/api/rpm/v1/platform/**`, and break-glass (J-297).
__exportStar(require("./rpm-platform.js"), exports);
__exportStar(require("./rpm-practice-configurations.js"), exports);
__exportStar(require("./rpm-workup.js"), exports);
// `RPM-026`: a notification attempt and the destinations a workup offers (J-221).
__exportStar(require("./rpm-attempts.js"), exports);
// `RPM-039`: held and batched calls (J-228).
__exportStar(require("./rpm-held-calls.js"), exports);
__exportStar(require("./rpm-summaries.js"), exports);
// `RPM-097`: the roster `GET /api/rpm/v1/facilities/:facilityId/residents` returns (J-214).
__exportStar(require("./rpm-residents.js"), exports);
// `RPM-085`: the warning the mirror's status facts call for, one reading for server and screen (J-307).
__exportStar(require("./resident-status.js"), exports);
const schema_js_1 = require("./db/schema.js");
var schema_js_2 = require("./db/schema.js");
Object.defineProperty(exports, "userPublicSchema", { enumerable: true, get: function () { return schema_js_2.userPublicSchema; } });
Object.defineProperty(exports, "sampleRecordSchema", { enumerable: true, get: function () { return schema_js_2.sampleRecordSchema; } });
/**
 * `RPM-102` row 2 — an administrative account row: the account's own identity, and the person
 * record STATED rather than left blank.
 *
 * Measured against the deployed catalogue on 2026-09-19: exactly three foreign keys reference
 * `people` — `people.merged_into_person_id`, `person_tenant_affiliations.person_id` and
 * `service_principals.accountable_person_id` — and not one of them links a HUMAN account to its own
 * person. That is `CR-12`'s deliberate non-foreign-key, read out of the catalogue rather than out of
 * the prose. So `NO_PERSON_RECORD_LINKED` is the permanent and correct state of every human account
 * here, and §6 asks the surface to say so: *"Not a blank, and not the string 'unknown': the absence
 * is a legitimate state and is displayed as one."*
 *
 * One field carries it, not two. A `linked` boolean beside `state` is the same fact twice, and two
 * facts that can disagree is what a report ends up arguing about.
 */
exports.adminAccountSchema = schema_js_1.userPublicSchema
    .extend({
    personRecord: zod_1.z
        .object({
        state: zod_1.z.enum(["NO_PERSON_RECORD_LINKED", "ACCOUNTABLE_PERSON_RECORDED"]),
        /**
         * The one account-to-person link this schema expresses: a service principal's accountable
         * owner, who is a DIFFERENT human from the machine actor (§4.1.5).
         */
        accountablePersonId: zod_1.z.uuid().nullable(),
    })
        .meta({ id: "PersonRecordLink" }),
})
    .meta({ id: "AdminAccount", description: "A staff account with its person record stated" });
// ---------- shared API primitives (land in OpenAPI components via .meta({ id })) ----------
exports.idParamSchema = zod_1.z.object({ id: zod_1.z.uuid() });
exports.errorSchema = zod_1.z
    .object({
    error: zod_1.z.string(),
    message: zod_1.z.string(),
    requestId: zod_1.z.string(),
    reason: zod_1.z.string().optional(),
    issues: zod_1.z
        .array(zod_1.z.object({ path: zod_1.z.array(zod_1.z.union([zod_1.z.string(), zod_1.z.number()])), message: zod_1.z.string() }))
        .optional(),
})
    .meta({ id: "ApiError" });
exports.healthSchema = zod_1.z
    .object({
    status: zod_1.z.literal("ok"),
    db: zod_1.z.enum(["ok", "error"]),
    version: zod_1.z.string(),
    requestId: zod_1.z.string(),
})
    .meta({ id: "Health" });
exports.pingSchema = zod_1.z
    .object({ pong: zod_1.z.literal(true), role: zod_1.z.string() })
    .meta({ id: "AdminPing" });
exports.listUsersQuerySchema = zod_1.z.object({
    limit: zod_1.z.coerce.number().int().min(1).max(100).default(20),
});
/** Public telemetry contract: browser OTLP/JSON posts to these same-origin paths (CR-13). */
exports.TELEMETRY_PATHS = {
    traces: "/api/telemetry/v1/traces",
    logs: "/api/telemetry/v1/logs",
};
// ---------- patients (J-041) ----------
// The Carease `patients` mirror is read-only (`.claude/rules/external-data.md`), so there is no
// insert or update schema here — only what leaves the server. Two shapes, deliberately:
//
//   - the SUMMARY is what a list returns. It carries no birthdate and no address, because a
//     list is the widest PHI exposure in the application: one request returns many patients, and
//     most callers of a list are choosing a row, not reading a chart.
//   - the DETAIL is what one record returns, and it carries the identifiers a clinician needs to
//     confirm they have the right person.
//
// The split is the minimum-necessary rule expressed as a type: a caller cannot accidentally receive
// a page of dates of birth, because the schema that validates the response has no field for one.
exports.patientSummarySchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    name: zod_1.z.string().nullable(),
    gender: zod_1.z.string().nullable(),
    status: zod_1.z.string().nullable(),
    facilityId: zod_1.z.string().nullable(),
    // Resolved through the facilities service. `facility_id` has no foreign key in this mirror —
    // the loader strips them (D-052) — so the name is joined in application code, and it is what a
    // screen shows: "Mercy West", not "F-0142". The id stays because a filter uses it. (J-042)
    facilityName: zod_1.z.string().nullable(),
    // No `location`. The mirror's `location` is unit, room and bed combined, and a second copy of
    // one fact can disagree with its own parts, so ChartVN does not read it (`03-RPM-SCHEMA.md`
    // §5.4, `RPM-031`, J-180).
    room: zod_1.z.string().nullable(),
    bed: zod_1.z.string().nullable(),
})
    .meta({ id: "PatientSummary" });
exports.patientDetailSchema = exports.patientSummarySchema
    .extend({
    firstName: zod_1.z.string().nullable(),
    middleName: zod_1.z.string().nullable(),
    lastName: zod_1.z.string().nullable(),
    // ISO 8601 strings, not `z.date()`. A response is JSON, and JSON has no date: `z.date()` gave
    // the OpenAPI document no type at all, so the generated client read `unknown | null` for every
    // date on the record. The repository converts on the way out, which is the one place that knows
    // the value came from a `timestamp` column.
    birthdate: zod_1.z.iso.datetime().nullable(),
    language: zod_1.z.string().nullable(),
    admittanceDate: zod_1.z.iso.datetime().nullable(),
    dischargeDate: zod_1.z.iso.datetime().nullable(),
    floor: zod_1.z.string().nullable(),
    unit: zod_1.z.string().nullable(),
})
    .meta({ id: "PatientDetail" });
/**
 * The list query. `cursor` is the last id of the previous page, not an offset.
 *
 * qa holds 134,041 rows. `OFFSET n` makes the database walk and discard n rows, so page 500 costs
 * five hundred pages of work to return one; a keyset comparison on the primary key costs the same
 * at every depth. The trade is that pages cannot be jumped to, which a worklist does not need.
 */
exports.listPatientsQuerySchema = zod_1.z.object({
    limit: zod_1.z.coerce.number().int().min(1).max(100).default(25),
    cursor: zod_1.z.string().max(20).optional(),
    facilityId: zod_1.z.string().max(20).optional(),
    status: zod_1.z.string().max(50).optional(),
});
exports.patientPageSchema = zod_1.z
    .object({
    items: zod_1.z.array(exports.patientSummarySchema),
    /** The id to pass as `cursor` for the next page; absent on the last page. */
    nextCursor: zod_1.z.string().optional(),
})
    .meta({ id: "PatientPage" });
/**
 * The path parameter. NOT a uuid: the Carease `patients.id` is a varchar(20) assigned by the source
 * system, and `.claude/rules/phi.md` §2 requires an OPAQUE identifier — which this is — rather than
 * a uuid specifically. The pattern keeps a name, a date or an MRN-shaped value out of the path, so
 * an address that reaches a log or a screenshot still carries nothing about the person.
 */
exports.patientIdParamSchema = zod_1.z.object({
    patientId: zod_1.z
        .string()
        .min(1)
        .max(20)
        .regex(/^[A-Za-z0-9_-]+$/),
});
// ---------- facilities (J-042) ----------
// Also a read-only Carease mirror. Two tables, joined: `facilities` carries the operational record
// and `facilities_ext` the registry one, of which ChartVN reads the official name alone. The
// resident count returned beside it is computed, not taken from the registry. A facility is not
// PHI, so unlike a patient there is no summary and detail split; the whole row is safe to return.
exports.facilitySchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    city: zod_1.z.string().nullable(),
    state: zod_1.z.string().nullable(),
    timezone: zod_1.z.string().nullable(),
    // From facilities_ext, absent when the registry has no matching row. The join is a LEFT join for
    // that reason: an operational facility with no registry entry is a facility, not an error.
    // `official_name` is the one `facilities_ext` column ChartVN reads (`03-RPM-SCHEMA.md` §5.4):
    // no facility code and no stored count (J-180).
    officialName: zod_1.z.string().nullable(),
    // Computed from `carease.patients` at request time — the residents whose status is Current —
    // and never read from `facilities_ext.current_patient_count` (`RPM-096`, J-180). A count of no
    // rows is 0, so it is never null.
    currentPatientCount: zod_1.z.number().int().nonnegative(),
})
    .meta({ id: "Facility" });
/** The list query. 545 rows today, so this pages the same way patients does rather than differently. */
exports.listFacilitiesQuerySchema = zod_1.z.object({
    limit: zod_1.z.coerce.number().int().min(1).max(200).default(50),
    cursor: zod_1.z.string().max(20).optional(),
    state: zod_1.z.string().length(2).optional(),
});
exports.facilityPageSchema = zod_1.z
    .object({
    items: zod_1.z.array(exports.facilitySchema),
    nextCursor: zod_1.z.string().optional(),
})
    .meta({ id: "FacilityPage" });
/** Same shape as `patientIdParamSchema`, and no `.meta({ id })` for the same reason. */
exports.facilityIdParamSchema = zod_1.z.object({
    facilityId: zod_1.z
        .string()
        .min(1)
        .max(20)
        .regex(/^[A-Za-z0-9_-]+$/),
});
//# sourceMappingURL=index.js.map